import React from 'react';
import { Popover } from 'antd';
import { PhoneOutlined, MailOutlined } from '@ant-design/icons';
import Username from './Username';

const AssistantInfo = ({ assistant }) => {
  if (!assistant) return null;

  return (
    <Popover
      content={
        <div>
          <p>
            <PhoneOutlined style={{ marginRight: 12 }} />
            {assistant.tel}
          </p>
          <p>
            <MailOutlined style={{ marginRight: 12 }} />
            {assistant.email}
          </p>
        </div>
      }
      title={<Username user={assistant} />}
      trigger="hover"
    >
      <a>{<Username user={assistant} />}</a>
    </Popover>
  );
};

export default AssistantInfo;
